import { ProductsCategory, productsKeyConstants } from '../../../../../config';

export const categoryBasedContent = {
  [ProductsCategory.RELIEF_FACTOR]: {
    productKey: productsKeyConstants.RF_RELIEF_FACTOR_QS_NEC,
    tags: {
      overview: {
        key: 'overview',
        text: 'Overview',
        href: '#overview',
      },
      howitworks: {
        key: 'howitworks',
        text: 'How it Works',
        href: '#howitworks',
      },
      ingredients: {
        key: 'ingredients',
        text: 'Ingredients',
        href: '#ingredients',
      },
      testimonials: {
        key: 'testimonials',
        text: 'Testimonials',
        href: '#testimonials',
      },
      faq: {
        key: 'faq',
        text: 'FAQs',
        href: '#faq',
      },
    },
  },
  [ProductsCategory.ZEN_FACTOR]: {
    productKey: productsKeyConstants.RF_ZEN_FACTOR,
    tags: {
      overview: {
        key: 'overview',
        text: 'Overview',
        href: '#overview',
      },
      howitworks: {
        key: 'howitworks',
        text: 'How it Works',
        href: '#howitworks',
      },
      ingredients: {
        key: 'ingredients',
        text: 'Ingredients',
        href: '#ingredients',
      },
      testimonials: {
        key: 'testimonials',
        text: 'Testimonials',
        href: '#testimonials',
      },
      faq: {
        key: 'faq',
        text: 'FAQs',
        href: '#faq',
      },
    },
  },
  [ProductsCategory.GO_FACTOR]: {
    productKey: productsKeyConstants.RF_GO_FACTOR,
    tags: {
      overview: {
        key: 'overview',
        text: 'Overview',
        href: '#overview',
      },
      howitworks: {
        key: 'howitworks',
        text: 'How it Works',
        href: '#howitworks',
      },
      ingredients: {
        key: 'ingredients',
        text: 'Ingredients',
        href: '#ingredients',
      },
      testimonials: {
        key: 'testimonials',
        text: 'Testimonials',
        href: '#testimonials',
      },
      faq: {
        key: 'faq',
        text: 'FAQs',
        href: '#faq',
      },
    },
  },
  [ProductsCategory.Z_FACTOR]: {
    productKey: productsKeyConstants.RF_Z_FACTOR,
    tags: {
      overview: {
        key: 'overview',
        text: 'Overview',
        href: '#overview',
      },
      howitworks: {
        key: 'howitworks',
        text: 'How it Works',
        href: '#howitworks',
      },
      ingredients: {
        key: 'ingredients',
        text: 'Ingredients',
        href: '#ingredients',
      },
      testimonials: {
        key: 'testimonials',
        text: 'Testimonials',
        href: '#testimonials',
      },
      faq: {
        key: 'faq',
        text: 'FAQs',
        href: '#faq',
      },
    },
  },
};
